module.exports = __webpack_public_path__ + "static/img/icon_home_location.bb6cfe24.png";